import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { formatNumber } from '@nsftx/seven-nxg-retail-vue-sdk'
import { useCalculatorStore } from '@/stores/calculator/calculatorStore'

export const useCalculatorCashFlow = () => {
  const { t } = useI18n({ useScope: 'global' })
  const { cashFlow, currency } = storeToRefs(useCalculatorStore())

  const formattedMoneyIn = computed(() =>
    formatNumber(cashFlow.value.moneyIn, { style: 'decimal' }),
  )
  const formattedPayments = computed(() =>
    formatNumber(cashFlow.value.payments, { style: 'decimal' }),
  )
  const formattedPayouts = computed(() =>
    formatNumber(cashFlow.value.payouts, { style: 'decimal' }),
  )
  const formattedDisplayRest = computed(() =>
    formatNumber(cashFlow.value.displayRest, { style: 'decimal' }),
  )

  const restLabel = computed(() => {
    switch (cashFlow.value.restDirection) {
      case 'give_to_player':
        return t('calculator_give_to_player')
      case 'collect_from_player':
        return t('calculator_collect_from_player')
      default:
        return t('calculator_rest')
    }
  })

  const restAmountWithCurrency = computed(() => `${formattedDisplayRest.value} ${currency.value}`)

  const restVariant = computed(() => cashFlow.value.restDirection)

  return {
    cashFlow,
    currency,
    formattedMoneyIn,
    formattedPayments,
    formattedPayouts,
    formattedDisplayRest,
    restLabel,
    restAmountWithCurrency,
    restVariant,
  }
}
